import { OptionallyVisible } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import IconAdd from 'components/icons/add';
import IconCross from 'components/icons/cross';

import LABELS from './keys';
import { CheckIcon, CloseButton, Container, Divider, ResetButton, StatusLabel, StatusWrapper, TitanButton } from './styles';

type FormStatusControlsProps = {
  closeModal: () => void;
  resetData: () => void;
  onInsertTitanData: () => void;
  titanFormData?: unknown;
  isLoadingTitanData?: boolean;
};

export const FormControls = ({ closeModal, resetData, onInsertTitanData, titanFormData, isLoadingTitanData }: FormStatusControlsProps) => {
  const { t } = useTranslation();
  return (
    <Container>
      <StatusWrapper>
        <OptionallyVisible visible={Boolean(titanFormData)}>
          <TitanButton secondary onClick={onInsertTitanData} disabled={isLoadingTitanData}>
            <IconAdd />
            {isLoadingTitanData ? t(LABELS.LOADING) : t(LABELS.TITAN_DATA_BUTTON)}
          </TitanButton>
        </OptionallyVisible>
        <StatusLabel>
          <CheckIcon />
          {t(LABELS.SAVED)}
        </StatusLabel>
        <Divider />
        <ResetButton flat onClick={resetData}>
          {t(LABELS.CLEAR)}
        </ResetButton>
      </StatusWrapper>
      <CloseButton flat onClick={closeModal}>
        <IconCross />
      </CloseButton>
    </Container>
  );
};
